import {
  Component,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID, signal
} from '@angular/core';
import {LoginService} from './services/login.service';
import {UserService} from './services/user.service';
import {NavigationStart, Router, RouterLink, RouterModule, RouterOutlet} from '@angular/router';
import {UserDto} from './models/dtos/user-dto';
import {UserTypeEnum} from "./enums/user-type.enum";
import {WebsocketService} from "./services/websocket.service";
import {ToastModule} from "primeng/toast";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import { isPlatformBrowser } from "@angular/common";
import {DrawerModule} from "primeng/drawer";
import {DialogModule} from "primeng/dialog";
import {BadgeModule} from "primeng/badge";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {faFacebookF, faInstagram, faLinkedinIn, faTiktok, faYoutube} from "@fortawesome/free-brands-svg-icons";
import {InputSendComponent} from "./components/includes/input-send/input-send.component";
import {NewsletterService} from "./services/newsletter.service";
import {MessageCustomService} from "./services/message.custom.service";
import {SplitButtonModule} from "primeng/splitbutton";
import {faCaretDown, faXmark, faBars, faGem, faCircleUp} from '@fortawesome/free-solid-svg-icons';
import {environment} from "../environments/environment";
import {SsrCookieService} from "ngx-cookie-service-ssr";
import {TrackingService} from "./services/tracking.service";
import {SubscriptionTypeEnum} from "./enums/subscription-type";

class SubMenuItem {
  title: string
  url: string
  open?: boolean = false
  subItems: SubMenuSubItem[]
}

class SubMenuSubItem {
  title: string
  url: string
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [
    ToastModule,
    ConfirmDialogModule,
    DrawerModule,
    DialogModule,
    RouterOutlet,
    RouterModule,
    RouterLink,
    BadgeModule,
    FontAwesomeModule,
    InputSendComponent,
    SplitButtonModule
]
})
export class AppComponent implements OnInit {
  isPlatformBrowser = isPlatformBrowser
  subscription = this.loginService.subscription
  // Icons
  faFacebook = faFacebookF
  faInstagram = faInstagram
  faLinkedin = faLinkedinIn
  faTikTok = faTiktok
  faYoutube = faYoutube
  faBars = faBars
  faXMark = faXmark
  faCaretDown = faCaretDown

  UserTypeEnum = UserTypeEnum

  user: UserDto = new UserDto();

  connected = false;

  networkStatus: boolean = true;

  userType = this.loginService.userType

  scrollHeader = false
  showMenu = false

  subMenuItems: SubMenuItem[]

  constructor(private loginService: LoginService,
              private userService: UserService,
              public router: Router,
              private websocketService: WebsocketService,
              private newsletterService: NewsletterService,
              private messageCustomService: MessageCustomService,
              private cookieService: SsrCookieService,
              private trackingService: TrackingService,
              @Inject(PLATFORM_ID) public platformId: object) {
    this.subMenuItems = [
      {
        title: "Carte des cocktails",
        url: environment.frontUrl + "/cocktails",
        subItems: []
      },
      {
        title: "Nos prestations",
        url: "https://www.commandetonbarman.fr/ctb/",
        subItems: [
          {
            title: "Particuliers",
            url: "https://www.commandetonbarman.fr/ctb/nos-prestations/particuliers/"
          },
          {
            title: "Professionnels",
            url: "https://www.commandetonbarman.fr/ctb/nos-prestations/professionnels/"
          }
        ]
      },
      {
        title: "Conseils",
        url: "https://www.commandetonbarman.fr/ctb/category/actualites/conseils/",
        subItems: [
          {
            title: "Particuliers",
            url: "https://www.commandetonbarman.fr/ctb/category/actualites/conseils/particuliers/"
          },
          {
            title: "Professionnels",
            url: "https://www.commandetonbarman.fr/ctb/category/actualites/conseils/professionnels/"
          }
        ]
      },
      {
        title: "Recettes",
        url: "https://www.commandetonbarman.fr/ctb/category/actualites/recettes/",
        subItems: []
      },
      {
        title: "News",
        url: "https://www.commandetonbarman.fr/ctb/category/actualites/news/",
        subItems: []
      }
    ]
  }

  ngOnInit() {
    if(this.isPlatformBrowser(this.platformId)) {
      ['click', 'scroll', 'touchstart'].forEach(event => {
        window.addEventListener(event, this.onUserInteraction, {
          once: true,
          passive: true
        });
      });
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (!!event.url && event.url.match(/^\/#/)) {
          this.router.navigate([event.url.replace('/#', '')]);
        }
      }
    });
    if(this.userType() == null && this.cookieService.get("role") != null) {
      this.loginService.userType.set(this.cookieService.get("role") as UserTypeEnum)
    }
    if(this.loginService.subscription() == null && this.cookieService.get("subscription") != "") {
      this.loginService.subscription.set(this.cookieService.get("subscription") as SubscriptionTypeEnum)
    }
    if(isPlatformBrowser(this.platformId)) {
      this.networkStatus = navigator.onLine
    }
    //this.statService.addVisitor().subscribe(success => {});
    this.isConnected();
    this.documentHeight();
  }

  private onUserInteraction = (): void => {
    setTimeout(() => {
      this.trackingService.initAllTracking();
    }, 100);
  };

  @HostListener("window:online", ["$event"])
  onlineEvent(event) {
    if (event.type == "online") {
      this.networkStatus = true
    }
  }

  @HostListener("window:offline", ["$event"])
  offlineEvent(event) {
    if (event.type == "offline") {
      this.networkStatus = false
    }
  }

  // Fonction de déconnexion
  logout() {
    if(isPlatformBrowser(this.platformId)) {
      this.websocketService.deacticate();
    }
    this.loginService.logout();
    this.router.navigate(['/connexion'])
  }

  // Fonction executée lorsque la personne se connecte
  isConnected() {
    if(isPlatformBrowser(this.platformId)) {
      this.loginService.loadUser.subscribe(success => {
        this.connected = this.loginService.isConnected();
        if (this.connected) {
          this.userService.getCurrentUser().subscribe(user => {
            this.user = user
          }, error => {
            this.loginService.logout()
          });
        }
      });
    }
  }

  register() {
    this.router.navigate(['/connexion']);
  }

  toProfil() {
    this.router.navigate(['/compte/informations']);
  }

  addNewsletter(email: string) {
    this.newsletterService.addNewsletter(email).subscribe(success => {
      this.messageCustomService.success("Merci de vous être inscrit à la newsletter !")
    })
  }

  @HostListener("window:scroll", []) onWindowScroll() {
    if(isPlatformBrowser(this.platformId)) {
      this.showMenu = false
      if (window.scrollY == 0) {
        this.scrollHeader = false
      } else {
        this.scrollHeader = true
      }
    }
  }

  onActivate(e){
    if(isPlatformBrowser(this.platformId)) {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }

  noHeaderFooter(): boolean {
    return (this.router.url.includes('/connexion') && !this.router.url.includes('/reserver'))
      || this.router.url.includes('/reinitialiser-mot-de-passe')
      || this.router.url.includes('/mot-de-passe-oublie')
      || this.router.url.includes('/search-iframe')
  }

  noFooter(): boolean {
    return this.router.url.includes('/commandes')
      || this.router.url.includes('/reserver')
      || this.router.url.includes('/compte')
      || this.router.url.includes('/abonnement')
  }

  documentHeight() {
    if(isPlatformBrowser(this.platformId)) {
      document.documentElement.style.setProperty('--window-height', `${window.innerHeight}px`)
    }
  }

  @HostListener("window:resize", []) onWindowResize() {
    this.documentHeight()
  }

  openSubMenu(item: SubMenuItem) {
    if(isPlatformBrowser(this.platformId) && item.open) {
      item.open = false
      window.location.href = item.url;
    } else {
      item.open = true
    }
  }

  openUrl(url: string) {
    if(isPlatformBrowser(this.platformId)) {
      window.location.href = url;
    }
  }

  protected readonly faGem = faGem;
  protected readonly SubscriptionTypeEnum = SubscriptionTypeEnum;
  protected readonly faCircleUp = faCircleUp;
}
